import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useTranslation } from "react-i18next";

export default function ProtectedRoute({
  children,
}: {
  children: JSX.Element;
}) {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-2xl text-black">
          ⏳ {t("common.loading")}
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log("🔒 ProtectedRoute - Not authenticated, redirecting to login");
    return <Navigate to="/admin/login" replace />;
  }

  console.log("🔒 ProtectedRoute - Authenticated, rendering children");
  return children;
}
